import { useServices } from "@/services-context";
import { HelpDesktop } from "./HelpDesktop.tsx";
import { HelpMobile } from "./HelpMobile.tsx";
import { LocationHook, RouteHook, useLocation, useRoute } from "preact-iso";
import { LayoutTypes, useLayoutType } from "@/util-react/layout.tsx";
import { Services } from "@/services/services.ts";
import { pageSuspense, useSuspenseLoader } from "@/helpers/suspense.tsx";
import { StaticPagesType } from "@/context/static-pages.ts";
import { Url } from "@/helpers/url.ts";
import { SeoMarkupDataset } from "@/services/seo-markup.ts";
import { PageTags } from "@/elements-react/document-elements/page-tags.tsx";

const fetchPageData = async (params: { services: Services; location: LocationHook; route: RouteHook }) => {
  const { services, location, route } = params;

  await services.initialize.prepare({
    location: location,
    route: route,
  });

  const registryUrl = Url.normalizeRoute(route.path);
  const alternates = await services.routes.resolveAlternates(registryUrl);

  if (!services.staticPages.has(StaticPagesType.help)) {
    await services.staticPages.fetchStaticPage(StaticPagesType.help);
  }

  return {
    type: "static",
    canonical: registryUrl,
    alternates: alternates,
  };
};

const getPageComponent = (layoutType: LayoutTypes) => {
  switch (layoutType) {
    case LayoutTypes.TYPE_DESKTOP:
      return HelpDesktop;
    case LayoutTypes.TYPE_MOBILE:
      return HelpMobile;
  }
};

export const HelpPage = pageSuspense(() => {
  const route = useRoute();
  const location = useLocation();
  const services = useServices();
  const { layoutType } = useLayoutType();

  const seoMarkupDataset = useSuspenseLoader({
    key: "help-route",
    loader: () =>
      fetchPageData({
        services: services,
        location: location,
        route: route,
      }),
  }) as SeoMarkupDataset;

  const content = services.staticPages.getStaticPage(StaticPagesType.help);
  const PageComponent = getPageComponent(layoutType);

  return (
    <div style={{ display: "contents" }}>
      <PageComponent content={content} />
      <PageTags seo={seoMarkupDataset} />
    </div>
  );
});
